import Stack, { type StackProps } from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import PayPalLogo from '@liquidweb-dev/undercurrent/logos/PayPal';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

import HookedSubmit from 'components/Form/HookedSubmit';

export interface ChoosePaymentMethodPayPalProps extends StackProps {
	isSubmitting: boolean;
}

/** Hands a one-time payment off to PayPal to be approved there */
const ChoosePaymentMethodPayPal = ({
	isSubmitting,
	sx,
	...rest
}: ChoosePaymentMethodPayPalProps) => {
	return (
		<Stack
			sx={combineSx({ gap: 200, paddingTop: 200, alignItems: 'center' }, sx)}
			{...rest}
		>
			<HookedSubmit
				variant="secondary"
				size="large"
				sx={{
					backgroundColor: '#FFC439',
					'&:hover': {
						backgroundColor: '#FFC43980',
					},
				}}
				aria-label="Continue with PayPal"
				loading={isSubmitting}
			>
				<Stack sx={{ flexDirection: 'row', gap: 100 }}>
					<span>Continue with</span>
					<PayPalLogo sx={{ height: '16px', width: '60px' }} />
				</Stack>
			</HookedSubmit>

			<Typography
				variant="body-md"
				sx={{ textAlign: 'center', maxWidth: '391px' }}
			>
				You&apos;re being redirected to PayPal. We&apos;ll bring you right back
				once payment is complete.
			</Typography>
		</Stack>
	);
};

export default ChoosePaymentMethodPayPal;
